module.exports = "<footer>\n\n  <p class=\"text-xs-center\">&copy; Copyright 2019. All rights reserved.</p>\n\n\n</footer>"